function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.23322 8.23172C7.99795 8.46314 7.81082 8.73886 7.68263 9.04296C7.55444 9.34707 7.48773 9.67354 7.48635 10.0036C7.48497 10.3336 7.54894 10.6606 7.67457 10.9658C7.80021 11.2709 7.98502 11.5482 8.21835 11.7816C8.45168 12.015 8.72891 12.1999 9.03405 12.3256C9.33919 12.4513 9.6662 12.5153 9.99621 12.514C10.3262 12.5127 10.6527 12.4461 10.9569 12.318C11.261 12.1898 11.5367 12.0028 11.7682 11.7676M12.2516 8.91339C12.0035 8.40096 11.5885 7.98809 11.0749 7.74255",
  stroke: "#223969",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33333 5H15.8333C16.2754 5 16.6993 5.17559 17.0118 5.48816C17.3244 5.80072 17.5 6.22464 17.5 6.66667V13.3333C17.5 13.5783 17.4467 13.8117 17.3517 14.0208M15 15H4.16667C3.72464 15 3.30072 14.8244 2.98816 14.5118C2.67559 14.1993 2.5 13.7754 2.5 13.3333V6.66667C2.5 6.22464 2.67559 5.80072 2.98816 5.48816C3.30072 5.17559 3.72464 5 4.16667 5H5M15 10H15.0083M5 10H5.00833M2.5 2.5L17.5 17.5",
  stroke: "#223969",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBankNoteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNoteOff);
export default __webpack_public_path__ + "static/media/bank-note-off.9c591dbd.svg";
export { ForwardRef as ReactComponent };